import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Modal, ModalHeader, ModalBody, ModalFooter,
  Button, Spinner
} from "reactstrap";

export default function TemplateLibraryModal({ strategyType, onClose, onImport }) {
  const [templates, setTemplates] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios.get(`/rules/templates/${strategyType}`)
      .then(res => { setTemplates(res.data || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, [strategyType]);

  return (
    <Modal isOpen toggle={onClose} size="lg">
      <ModalHeader toggle={onClose}>
        Template Library — {strategyType}
      </ModalHeader>

      <ModalBody>
        {loading && (
          <div style={{ textAlign: "center", padding: 30 }}>
            <Spinner color="primary" />
          </div>
        )}

        {!loading && templates.length === 0 && (
          <p style={{ color: "#888", textAlign: "center", padding: 20 }}>
            No templates found for {strategyType}.
          </p>
        )}

        {!loading && templates.map(t => {
          const isSelected = selected?.id === t.id;
          let ruleCount = 0;
          try { ruleCount = JSON.parse(t.template_json)?.length || 0; } catch {}

          return (
            <div
              key={t.id}
              onClick={() => setSelected(t)}
              style={{
                padding: "14px 16px",
                marginBottom: 10,
                borderRadius: 10,
                border: isSelected ? "2px solid #007bff" : "1px solid #e0e0e0",
                background: isSelected ? "#f0f7ff" : "#fff",
                cursor: "pointer",
                transition: "border 0.15s, background 0.15s",
              }}
            >
              <div style={{ fontWeight: 600, fontSize: 14 }}>
                {t.template_name}
              </div>
              {t.description && (
                <div style={{ fontSize: 12, color: "#666", marginTop: 4 }}>
                  {t.description}
                </div>
              )}
              <div style={{ fontSize: 11, color: "#999", marginTop: 4 }}>
                {ruleCount} rule{ruleCount !== 1 ? "s" : ""}
              </div>
            </div>
          );
        })}
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" outline onClick={onClose}>
          Cancel
        </Button>
        <Button
          color="primary"
          disabled={!selected}
          onClick={() => {
            try {
              onImport(JSON.parse(selected.template_json));
            } catch {
              alert("Failed to parse template.");
            }
          }}
        >
          Import Template
        </Button>
      </ModalFooter>
    </Modal>
  );
}
